// import React, { useState, useRef } from "react";
// import {
//   Modal,
//   Dialog,
//   DialogContent,
//   Typography,
//   Button,
//   Box,
//   Stack,
//   Chip,
//   Divider,
//   Alert,
//   useTheme,
//   IconButton,
//   Snackbar,
// } from "@mui/material";
// import QRCode from "react-qr-code";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import DownloadIcon from "@mui/icons-material/Download";
// import CloseIcon from "@mui/icons-material/Close";

// export default function GetQRCodeModal({ seller, name }) {
//   const qrRef = useRef(null);
//   const theme = useTheme();
//   const [snackbarOpen, setSnackbarOpen] = React.useState(false);
//   const [open, setOpen] = useState(false);

//   // Extract seller details
//   const hasUPI = !!seller?.upiId && seller.upiId.trim() !== "";
//   const sellerName = name || seller?.name || "Seller";

//   // Generate QR value based on available payment methods
//   const getQRValue = () => {
//     if (hasUPI) {
//       return `upi://pay?pa=${seller.upiId}&pn=${
//         sellerName || "N/A"
//       }&am=&cu=INR&tn=Payment%20via%20BizBridge`;
//     } else {
//       return `BizBridge Payment:
// Seller: ${sellerName}
// Bank: ${seller?.bankName || "N/A"}
// Account: ${seller?.accountNumber || "N/A"}
// IFSC: ${seller?.ifscCode || "N/A"}`;
//     }
//   };

//   // Copy UPI ID to clipboard
//   const handleCopyUPI = () => {
//     if (seller?.upiId) {
//       navigator.clipboard.writeText(seller.upiId);
//       setSnackbarOpen(true);
//     }
//   };

//   // Handle modal open
//   const handleOpen = () => {
//     setOpen(true);
//   };

//   // Handle modal close
//   const handleClose = () => {
//     setOpen(false);
//   };

//   // Download QR as PNG with enhanced design
//   const handleDownloadQR = () => {
//     const svg = qrRef.current.querySelector("svg");
//     if (!svg) return;

//     // Clone the SVG to avoid modifying the original
//     const clonedSvg = svg.cloneNode(true);

//     // Add logo directly to the cloned SVG
//     const logoSize = 50;
//     const logoX = 110; // Center of QR (220/2 = 110)
//     const logoY = 110;

//     // Create logo circle group
//     const logoGroup = document.createElementNS(
//       "http://www.w3.org/2000/svg",
//       "g",
//     );
//     logoGroup.setAttribute("id", "qr-logo");

//     // Create white circle background
//     const circle = document.createElementNS(
//       "http://www.w3.org/2000/svg",
//       "circle",
//     );
//     circle.setAttribute("cx", logoX);
//     circle.setAttribute("cy", logoY);
//     circle.setAttribute("r", logoSize / 2);
//     circle.setAttribute("fill", "#ffffff");
//     circle.setAttribute("stroke", "#1976d2");
//     circle.setAttribute("stroke-width", "3");

//     // Create "B" text
//     const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
//     text.setAttribute("x", logoX);
//     text.setAttribute("y", logoY + 8);
//     text.setAttribute("text-anchor", "middle");
//     text.setAttribute("font-family", "Arial, sans-serif");
//     text.setAttribute("font-size", "24");
//     text.setAttribute("font-weight", "bold");
//     text.setAttribute("fill", "#1976d2");
//     text.textContent = "B";

//     logoGroup.appendChild(circle);
//     logoGroup.appendChild(text);
//     clonedSvg.appendChild(logoGroup);

//     const serializer = new XMLSerializer();
//     const svgStr = serializer.serializeToString(clonedSvg);

//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");
//     const img = new Image();

//     // Enhanced canvas size for better design
//     canvas.width = 400;
//     canvas.height = 500;

//     img.onload = () => {
//       // Gradient background
//       const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
//       gradient.addColorStop(0, "#1976d2");
//       gradient.addColorStop(1, "#2196f3");

//       // Draw header background
//       ctx.fillStyle = gradient;
//       ctx.fillRect(0, 0, canvas.width, 80);

//       // White main background
//       ctx.fillStyle = "#ffffff";
//       ctx.fillRect(0, 80, canvas.width, canvas.height - 80);

//       // Add BizBridge Pay title
//       ctx.fillStyle = "#ffffff";
//       ctx.font = "bold 28px 'Arial', sans-serif";
//       ctx.textAlign = "center";
//       ctx.fillText("BizBridge Pay", canvas.width / 2, 45);

//       // Add tagline
//       ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
//       ctx.font = "14px 'Arial', sans-serif";
//       ctx.fillText("Secure & Fast Payments", canvas.width / 2, 70);

//       // Draw QR code with shadow
//       ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
//       ctx.shadowBlur = 10;
//       ctx.shadowOffsetX = 0;
//       ctx.shadowOffsetY = 2;
//       ctx.drawImage(img, 75, 120, 250, 250);
//       ctx.shadowBlur = 0;

//       // Draw decorative border around QR
//       ctx.strokeStyle = "#1976d2";
//       ctx.lineWidth = 2;
//       ctx.strokeRect(70, 115, 260, 260);

//       // Add payment type label
//       ctx.fillStyle = hasUPI ? "#28a745" : "#17a2b8";
//       ctx.font = "bold 16px 'Arial', sans-serif";
//       ctx.fillText(
//         hasUPI ? "UPI PAYMENT" : "BANK TRANSFER",
//         canvas.width / 2,
//         400,
//       );

//       // Add instruction
//       ctx.fillStyle = "#333333";
//       ctx.font = "18px 'Arial', sans-serif";
//       ctx.fillText("Scan QR Code to Pay", canvas.width / 2, 430);

//       // Add seller info
//       ctx.fillStyle = "#666666";
//       ctx.font = "16px 'Arial', sans-serif";
//       ctx.fillText(`Pay to: ${sellerName}`, canvas.width / 2, 460);

//       // Add UPI ID if available
//       if (hasUPI) {
//         ctx.fillStyle = "#1976d2";
//         ctx.font = "14px 'Arial', sans-serif";
//         ctx.fillText(`UPI ID: ${seller.upiId}`, canvas.width / 2, 485);
//       }

//       const pngFile = canvas.toDataURL("image/png", 1.0);
//       const downloadLink = document.createElement("a");
//       downloadLink.download = `BizBridge-Pay-${sellerName.replace(
//         /\s+/g,
//         "-",
//       )}.png`;
//       downloadLink.href = pngFile;
//       document.body.appendChild(downloadLink);
//       downloadLink.click();
//       document.body.removeChild(downloadLink);
//     };

//     img.src =
//       "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgStr)));
//   };

//   // Check if seller has any bank details
//   const hasBankDetails = seller?.bankName || seller?.accountNumber;

//   return (
//     <>
//       <Button
//         startIcon={<QrCode2Icon />}
//         variant="outlined"
//         sx={{ borderRadius: 2 }}
//         onClick={handleOpen}
//       >
//         Pay
//       </Button>

//       <Modal open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <Dialog maxWidth="sm" fullWidth open={open} onClose={handleClose}>
//           <DialogContent sx={{ textAlign: "center", py: 4, px: 3 }}>
//             <Box
//               sx={{
//                 background: "linear-gradient(45deg, #1976d2 30%, #2196f3 90%)",
//                 borderRadius: 2,
//                 py: 2,
//                 mb: 3,
//                 color: "white",
//               }}
//             >
//               <Typography variant="h5" fontWeight={800}>
//                 BizBridge Pay
//               </Typography>
//               <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                 Secure & Fast Payments
//               </Typography>
//             </Box>

//             {/* Payment Method Chip */}
//             <Box sx={{ mb: 3 }}>
//               <Chip
//                 icon={hasUPI ? <QrCode2Icon /> : <AccountBalanceIcon />}
//                 label={hasUPI ? "UPI Payment" : "Bank Transfer"}
//                 color={hasUPI ? "success" : "info"}
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: "0.9rem",
//                   py: 1,
//                   px: 2,
//                 }}
//               />
//             </Box>

//             <Divider sx={{ mb: 3 }}>
//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 fontWeight={600}
//               >
//                 SCAN TO PAY
//               </Typography>
//             </Divider>

//             {/* Show error if no payment details */}
//             {!hasUPI && !hasBankDetails ? (
//               <Alert severity="warning" sx={{ mb: 3 }}>
//                 <Typography variant="body1" fontWeight={600}>
//                   No payment details available
//                 </Typography>
//                 <Typography variant="body2">
//                   Please ask the seller to add UPI or bank details.
//                 </Typography>
//               </Alert>
//             ) : (
//               <>
//                 {/* QR Code with Logo */}
//                 <Box
//                   sx={{ position: "relative", display: "inline-block", mb: 4 }}
//                 >
//                   <Box
//                     ref={qrRef}
//                     sx={{
//                       p: 3,
//                       border: "2px solid",
//                       borderColor: "primary.light",
//                       borderRadius: 3,
//                       bgcolor: "#fff",
//                       boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
//                       position: "relative",
//                     }}
//                   >
//                     <QRCode
//                       value={getQRValue()}
//                       size={220}
//                       bgColor="#ffffff"
//                       fgColor="#000000"
//                       level="H"
//                     />
//                     {/* Logo overlay - now properly integrated */}
//                     <Box
//                       sx={{
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)",
//                         width: 50,
//                         height: 50,
//                         borderRadius: "50%",
//                         bgcolor: "white",
//                         border: "3px solid",
//                         borderColor: "primary.main",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       }}
//                     >
//                       <Typography
//                         variant="h6"
//                         fontWeight={900}
//                         color="primary.main"
//                         sx={{ lineHeight: 1 }}
//                       >
//                         B
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* UPI ID Display with Copy Button */}
//                 {hasUPI && (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: 2,
//                       mb: 3,
//                       p: 2,
//                       bgcolor: "grey.50",
//                       borderRadius: 2,
//                       border: "1px solid",
//                       borderColor: "grey.200",
//                     }}
//                   >
//                     <Typography variant="body1" fontWeight={600}>
//                       UPI ID:
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         fontFamily: "monospace",
//                         bgcolor: "white",
//                         px: 2,
//                         py: 1,
//                         borderRadius: 1,
//                         border: "1px solid",
//                         borderColor: "grey.300",
//                         minWidth: 200,
//                         textAlign: "center",
//                       }}
//                     >
//                       {seller.upiId}
//                     </Typography>
//                     <IconButton
//                       onClick={handleCopyUPI}
//                       size="small"
//                       sx={{
//                         bgcolor: "primary.main",
//                         color: "white",
//                         "&:hover": {
//                           bgcolor: "primary.dark",
//                         },
//                       }}
//                     >
//                       <ContentCopyIcon />
//                     </IconButton>
//                   </Box>
//                 )}

//                 {/* Instructions */}
//                 <Typography
//                   variant="body1"
//                   fontWeight={600}
//                   gutterBottom
//                   color="primary"
//                 >
//                   {hasUPI
//                     ? "Scan with PhonePe, GPay, or any UPI app"
//                     : "Scan to view bank transfer details"}
//                 </Typography>

//                 <Typography variant="body2" color="textSecondary" mb={3}>
//                   Pay to: <strong>{sellerName}</strong>
//                 </Typography>

//                 {/* Bank Details Section */}
//                 {!hasUPI && hasBankDetails && (
//                   <Alert
//                     severity="info"
//                     sx={{
//                       textAlign: "left",
//                       mb: 3,
//                       borderRadius: 2,
//                       "& .MuiAlert-icon": { alignItems: "center" },
//                     }}
//                   >
//                     <Typography
//                       variant="subtitle2"
//                       fontWeight={600}
//                       gutterBottom
//                     >
//                       Bank Transfer Details:
//                     </Typography>
//                     <Stack spacing={1}>
//                       {seller?.bankName && (
//                         <Typography variant="body2">
//                           <strong>Bank:</strong> {seller.bankName}
//                         </Typography>
//                       )}
//                       {seller?.accountNumber && (
//                         <Typography variant="body2">
//                           <strong>Account:</strong> {seller.accountNumber}
//                         </Typography>
//                       )}
//                       {seller?.accountName && (
//                         <Typography variant="body2">
//                           <strong>Name:</strong> {seller.accountName}
//                         </Typography>
//                       )}
//                       {seller?.ifscCode && (
//                         <Typography variant="body2">
//                           <strong>IFSC:</strong> {seller.ifscCode}
//                         </Typography>
//                       )}
//                       {seller?.branchName && (
//                         <Typography variant="body2">
//                           <strong>Branch:</strong> {seller.branchName}
//                         </Typography>
//                       )}
//                       {seller?.branchAddress && (
//                         <Typography variant="body2">
//                           <strong>Address:</strong> {seller.branchAddress}
//                         </Typography>
//                       )}
//                     </Stack>
//                   </Alert>
//                 )}
//               </>
//             )}

//             {/* Action Buttons */}
//             <Stack spacing={2} sx={{ mt: 4 }}>
//               {hasUPI || hasBankDetails ? (
//                 <Button
//                   variant="contained"
//                   onClick={handleDownloadQR}
//                   startIcon={<DownloadIcon />}
//                   sx={{
//                     borderRadius: 2,
//                     py: 1.5,
//                     fontWeight: 700,
//                     fontSize: "1rem",
//                     background:
//                       "linear-gradient(45deg, #1976d2 30%, #2196f3 90%)",
//                     boxShadow: "0 3px 5px 2px rgba(33, 150, 243, .3)",
//                   }}
//                 >
//                   Download QR Code
//                 </Button>
//               ) : null}

//               <Button
//                 variant="outlined"
//                 onClick={handleClose}
//                 startIcon={<CloseIcon />}
//                 sx={{
//                   borderRadius: 2,
//                   py: 1.5,
//                   fontWeight: 600,
//                   fontSize: "1rem",
//                   borderWidth: 2,
//                   "&:hover": { borderWidth: 2 },
//                 }}
//               >
//                 Close
//               </Button>
//             </Stack>
//           </DialogContent>
//         </Dialog>
//       </Modal>

//       {/* Snackbar for copy confirmation */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         message="UPI ID copied to clipboard!"
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       />
//     </>
//   );
// }


import React, { useState, useRef } from "react";
import {
    Modal,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Stack,
  Chip,
  Divider,
  Alert,
  useTheme,
  IconButton,
  Snackbar,
} from "@mui/material";
import QRCode from "react-qr-code";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import QRLogo from "../Images/BizBridge-Logo-1.png";
export default function GetQRCodeModal({ seller, name }) {
  const qrRef = useRef(null);
  const theme = useTheme();
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [open, setOpen] = useState(false);
  
  // Extract seller details
  const hasUPI = !!seller?.upiId && seller.upiId.trim() !== "";
  const sellerName = name || seller?.name || "Seller";

  // Generate QR value based on available payment methods
  const getQRValue = () => {
    if (hasUPI) {
      return `upi://pay?pa=${seller.upiId}&pn=${
        sellerName || "N/A"
      }&am=&cu=INR&tn=Payment%20via%20BizBridge`;
    } else {
      return `BizBridge Payment:
Seller: ${sellerName}
Bank: ${seller?.bankName || "N/A"}
Account: ${seller?.accountNumber || "N/A"}
IFSC: ${seller?.ifscCode || "N/A"}`;
    }
  };

  // Copy UPI ID to clipboard
  const handleCopyUPI = () => {
    if (seller?.upiId) {
      navigator.clipboard.writeText(seller.upiId);
      setSnackbarOpen(true);
    }
  };

  // Handle modal open
  const handleOpen = () => {
    setOpen(true);
  };

  // Handle modal close
  const handleClose = () => {
    setOpen(false);
  };

  // Download QR as PNG with enhanced design and logo drawn directly on canvas
  const handleDownloadQR = () => {
    const svg = qrRef.current.querySelector("svg");
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const qrImg = new Image();

    canvas.width = 400;
    canvas.height = 500;

    qrImg.onload = () => {
      // Gradient background
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      gradient.addColorStop(0, "#0B4064");
      gradient.addColorStop(1, "#0b4064");

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, 80);

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 80, canvas.width, canvas.height - 80);

      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 28px 'Arial', sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("BizBridge Pay", canvas.width / 2, 45);

      ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
      ctx.font = "14px 'Arial', sans-serif";
      ctx.fillText("Secure & Fast Payments", canvas.width / 2, 70);

      // Draw QR code with shadow
      ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
      ctx.shadowBlur = 10;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 2;
      ctx.drawImage(qrImg, 75, 120, 250, 250);
      ctx.shadowBlur = 0;

      // Draw decorative border around QR
      ctx.strokeStyle = "#0B4064";
      ctx.lineWidth = 2;
      ctx.strokeRect(70, 115, 260, 260);

      // Now load and draw the logo on top of the QR code
      const logoImg = new Image();
      logoImg.crossOrigin = "anonymous";
      
      logoImg.onload = () => {
        // Calculate center position for logo
        const qrCenterX = 75 + 250 / 2; // 200
        const qrCenterY = 120 + 250 / 2; // 245
        const logoSize = 60;
        
        // Draw white circle background for logo
        ctx.fillStyle = "#ffffff";
        ctx.beginPath();
        ctx.arc(qrCenterX, qrCenterY, logoSize / 2, 0, Math.PI * 2);
        ctx.fill();
        
        // Draw blue circle border
        ctx.strokeStyle = "#0B4064";
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(qrCenterX, qrCenterY, logoSize / 2, 0, Math.PI * 2);
        ctx.stroke();
        
        // Draw logo image in center
        const logoDrawSize = 45;
        ctx.drawImage(
          logoImg,
          qrCenterX - logoDrawSize / 2.1,
          qrCenterY - logoDrawSize / 1.6,
          logoDrawSize,
          logoDrawSize
        );

        // Continue with rest of the design
        finishCanvas();
      };

      logoImg.onerror = () => {
        console.error("Logo failed to load, continuing without it");
        finishCanvas();
      };

      const finishCanvas = () => {
        // Add payment type label
        ctx.fillStyle = hasUPI ? "#28a745" : "#17a2b8";
        ctx.font = "bold 16px 'Arial', sans-serif";
        ctx.fillText(
          hasUPI ? "UPI PAYMENT" : "BANK TRANSFER",
          canvas.width / 2,
          400
        );

        // Add instruction
        ctx.fillStyle = "#333333";
        ctx.font = "18px 'Arial', sans-serif";
        ctx.fillText("Scan QR Code to Pay", canvas.width / 2, 430);

        // Add seller info
        ctx.fillStyle = "#666666";
        ctx.font = "16px 'Arial', sans-serif";
        ctx.fillText(`Pay to: ${sellerName}`, canvas.width / 2, 460);

        // Add UPI ID if available
        if (hasUPI) {
          ctx.fillStyle = "#0B4064";
          ctx.font = "14px 'Arial', sans-serif";
          ctx.fillText(`UPI ID: ${seller.upiId}`, canvas.width / 2, 485);
        }

        const pngFile = canvas.toDataURL("image/png", 1.0);
        const downloadLink = document.createElement("a");
        downloadLink.download = `BizBridge-Pay-${sellerName.replace(
          /\s+/g,
          "-"
        )}.png`;
        downloadLink.href = pngFile;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };

      logoImg.src = window.location.origin + "/QrImg.png";
    };

    qrImg.src =
      "data:image/svg+xml;base64," +
      btoa(unescape(encodeURIComponent(svgStr)));
  };

  // Check if seller has any bank details
  const hasBankDetails = seller?.bankName || seller?.accountNumber;

  return (
    <>
      <Button
        startIcon={<QrCode2Icon />}
        variant="outlined"
        sx={{ borderRadius: 2,  }}
        onClick={handleOpen} 
      >
        Pay 
      </Button>
      
      <Modal
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <Dialog maxWidth="sm" fullWidth open={open} onClose={handleClose}>
          <DialogContent sx={{ textAlign: "center", py: 4, px: 3 }}>
            <Box
              sx={{
                background: "linear-gradient(45deg, #0B4064 30%, #0b4064 90%)",
                borderRadius: 2,
                py: 2,
                mb: 3,
                color: "white",
              }}
            >
              <Typography variant="h5" fontWeight={800}>
                BizBridge Pay
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Secure & Fast Payments
              </Typography>
            </Box>

            {/* Payment Method Chip */}
            <Box sx={{ mb: 3 }}>
              <Chip
                icon={hasUPI ? <QrCode2Icon /> : <AccountBalanceIcon />}
                label={hasUPI ? "UPI Payment" : "Bank Transfer"}
                color={hasUPI ? "success" : "info"}
                sx={{
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  py: 1,
                  px: 2,
                }}
              />
            </Box>

            <Divider sx={{ mb: 3 }}>
              <Typography variant="body2" color="textSecondary" fontWeight={600}>
                SCAN TO PAY
              </Typography>
            </Divider>

            {/* Show error if no payment details */}
            {!hasUPI && !hasBankDetails ? (
              <Alert severity="warning" sx={{ mb: 3 }}>
                <Typography variant="body1" fontWeight={600}>
                  No payment details available
                </Typography>
                <Typography variant="body2">
                  Please ask the seller to add UPI or bank details.
                </Typography>
              </Alert>
            ) : (
              <>
                {/* QR Code with Logo */}
                <Box
                  sx={{ position: "relative", display: "inline-block", mb: 4 }}
                >
                  <Box
                    ref={qrRef}
                    sx={{
                      p: 3,
                      border: "2px solid",
                      borderColor: "primary.light",
                      borderRadius: 3,
                      bgcolor: "#fff",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      position: "relative",
                    }}
                  >
                    <QRCode
                      value={getQRValue()}
                      size={220}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                    />
                    {/* Logo overlay */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        bgcolor: "white",
                        border: "3px solid",
                        borderColor: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        overflow: "hidden",
                      }}
                    >
                      <img 
                        src={QRLogo}
                        alt="BizBridge Logo"
                        style={{
                          width: '35px',
                          height: '35px',
                          objectFit: 'contain'
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                {/* UPI ID Display with Copy Button */}
                {hasUPI && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      mb: 3,
                      p: 2,
                      bgcolor: "grey.50",
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: "grey.200",
                    }}
                  >
                    <Typography variant="body1" fontWeight={600}>
                      UPI ID:
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: "monospace",
                        bgcolor: "white",
                        px: 2,
                        py: 1,
                        borderRadius: 1,
                        border: "1px solid",
                        borderColor: "grey.300",
                        minWidth: 200,
                        textAlign: "center",
                      }}
                    >
                      {seller.upiId}
                    </Typography>
                    <IconButton
                      onClick={handleCopyUPI}
                      size="small"
                      sx={{
                        bgcolor: "primary.main",
                        color: "white",
                        "&:hover": {
                          bgcolor: "primary.dark",
                        },
                      }}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Box>
                )}

                {/* Instructions */}
                <Typography
                  variant="body1"
                  fontWeight={600}
                  gutterBottom
                  color="primary"
                >
                  {hasUPI
                    ? "Scan with PhonePe, GPay, or any UPI app"
                    : "Scan to view bank transfer details"}
                </Typography>

                <Typography variant="body2" color="textSecondary" mb={3}>
                  Pay to: <strong>{sellerName}</strong>
                </Typography>

                {/* Bank Details Section */}
                {!hasUPI && hasBankDetails && (
                  <Alert
                    severity="info"
                    sx={{
                      textAlign: "left",
                      mb: 3,
                      borderRadius: 2,
                      "& .MuiAlert-icon": { alignItems: "center" },
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                      Bank Transfer Details:
                    </Typography>
                    <Stack spacing={1}>
                      {seller?.bankName && (
                        <Typography variant="body2">
                          <strong>Bank:</strong> {seller.bankName}
                        </Typography>
                      )}
                      {seller?.accountNumber && (
                        <Typography variant="body2">
                          <strong>Account:</strong> {seller.accountNumber}
                        </Typography>
                      )}
                      {seller?.accountName && (
                        <Typography variant="body2">
                          <strong>Name:</strong> {seller.accountName}
                        </Typography>
                      )}
                      {seller?.ifscCode && (
                        <Typography variant="body2">
                          <strong>IFSC:</strong> {seller.ifscCode}
                        </Typography>
                      )}
                      {seller?.branchName && (
                        <Typography variant="body2">
                          <strong>Branch:</strong> {seller.branchName}
                        </Typography>
                      )}
                      {seller?.branchAddress && (
                        <Typography variant="body2">
                          <strong>Address:</strong> {seller.branchAddress}
                        </Typography>
                      )}
                    </Stack>
                  </Alert>
                )}
              </>
            )}

            {/* Action Buttons */}
            <Stack spacing={2} sx={{ mt: 4 }}>
              {hasUPI || hasBankDetails ? (
                <Button
                  variant="contained"
                  onClick={handleDownloadQR}
                  startIcon={<DownloadIcon />}
                  sx={{
                    borderRadius: 2,
                    py: 1.5,
                    fontWeight: 700,
                    fontSize: "1rem",
                    background:
                      "linear-gradient(45deg, #0B4064 30%, #0b4064 90%)",
                    boxShadow: "0 3px 5px 2px rgba(33, 150, 243, .3)",
                  }}
                >
                  Download QR Code
                </Button>
              ) : null}

              <Button
                variant="outlined"
                onClick={handleClose}
                startIcon={<CloseIcon />}
                sx={{
                  borderRadius: 2,
                  py: 1.5,
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderWidth: 2,
                  "&:hover": { borderWidth: 2 },
                }}
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      </Modal>

      {/* Snackbar for copy confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="UPI ID copied to clipboard!"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
}